import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useRevalidator, useLocation, useNavigate, useParams, useLoaderData, useOutletContext } from 'react-router-dom';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import swal from 'sweetalert';
import _ from 'lodash';
import PageTitle from '../../organisms/pageTitle/pageTitle';
import MainHubPageTitle from '../../organisms/mainHubPageTitle/mainHubPageTitle';
import SimplePageTitle from '../../molecules/pageTitle/pageTitle';
import TableSection from '../../organisms/tableSection/tableSectionv2';

import {
  getItems,
  getSearchedItems,
  resetList,
  createItem,
  updateItems,
  updateRowItems,
  updateItem,
  removeItem,
  tableEdited,
  updateLocalItem,
  getSortedItems,
  bulk,
} from '../../../store/externalCalls/api/listTableApi';
import { storeStructure } from '../../../store/reducers';
import {
  composeURL, checkObjectAttributes, getURLParams, appendParamsToURL, getPartialPath,
} from '../../../utils/urlTools';
import FooterButton from '../../molecules/formFooter/formFooter';
import PreventTransitions from '../../molecules/preventTransitions/preventTransitions';
import Broadcast from '../../../store/externalCalls/broadcast';
import FormUploadSync from '../../molecules/formUploadSync/formUploadSync';
import Button, { ButtonTheme } from '../../atoms/button/button';
import { httpGet, httpGetFile, httpPost } from '../../../store/externalCalls/httpCalls';
import Label from '../../atoms/label/label';
import WebsocketLog from '../../organisms/WebsocketLog/websocketLog';
import Toaste from '../../atoms/toast/toaste';
import { getCookie } from '../../../store/sessionStore';
import LoadingSpinnerPage from '../../atoms/loadingSpinnerPage/loadingSpinnerPage';
import '../../pages/homePage/homePage.scss';

const ListTableTemplate = (props) => {
  const {
    // classId,
    configFile,
    onCreate,
    onSave,
    onDelete,
    onChange,
    selValue,
    withSessionVariables,
  } = props;

  const loaderData = useLoaderData();
  const contextLoaderData = useOutletContext() || {};
  const { changeAppRedirectTo, sportRoomId, configs, currentconfigId, onChangeMainHubConfig, mainHubConfigRef, setIsSpaceSelectDisabled} = contextLoaderData;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { revalidate } = useRevalidator();
  // const errorRef = useRef(null);
  const values = useSelector((state) => state[storeStructure.ListTable], shallowEqual);
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const itemChanged = useSelector((state) => state.session.isBlocking);
  const [updatedValues, setUpdateValues] = useState();
  const [itemsSelected, setitemsSelected] = useState([]);
  const [searchParams, setSearchParams] = useState();
  const [websocketLogOpen, setWebsocketLogOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [exports, setExports] = useState({});
  const [buttonError, setButtonError] = useState(null);
  const [buttonExport, setButtonExport] = useState(null);
  const [userNavigation, setUserNavigation] = useState([]);
  const serializedState = getCookie('state');
  const [showImportPopup, setShowImportPopup] = useState(false);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const id = configFile.idAttribute !== undefined
    ? (params[configFile.idAttribute] ?? loaderData?.[configFile.id]) : undefined;

  const handlerChangePage = (url) => {
    const currentParams = new URLSearchParams(window.location.search);
    const incomingParams = new URLSearchParams(getURLParams(url));
    const baseUrl = url.split('?')[0];
    const initialUrl = composeURL(session, configFile.sessionParams, configFile.getURL, id);
    if (!currentParams.has('page')) {
      for (const [k, v] of incomingParams.entries()) {
        currentParams.set(k, v);
      }
      getItems(`${baseUrl}?${currentParams.toString()}`, dispatch);
      if (!selValue) {
        navigate(`?${currentParams.toString()}` ,{
           state: {
            from: location.pathname,
          },
        });
      }
    } else {
      for (const [k, v] of incomingParams.entries()) {
        currentParams.set(k, v);
      }
      getItems(`${initialUrl}?${currentParams.toString()}`, dispatch);
      navigate(`?${currentParams.toString()}`,{
           state: {
            from: location.pathname,
          }
        },);
    }
  };
  const handleFilter = (filters) => {
    const encodedFilters = Object.fromEntries(
      Object.entries(filters)
        .filter(([key, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => [key, encodeURIComponent(String(value))])
    );
    const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
    const searchURL = appendParamsToURL(url, encodedFilters);
    window.history.pushState({}, '', appendParamsToURL('', encodedFilters));

    getSearchedItems(searchURL, dispatch);
  };

  const handlerSort = (sort) => {
    const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const { attributeName, sortDown } = sort;
    const orderList = sortDown ? 'asc' : 'desc';
    const obj = {
      sort_by: attributeName,
      order: orderList,
    };

    if (queryString.length === 0) {
      const searchURL = appendParamsToURL(url, obj);
      setSearchParams(searchURL);
      getSortedItems(searchURL, dispatch);
      window.history.pushState({}, '', appendParamsToURL('', obj));
    } else if (!urlParams.has('order')) {
      const urlWithParams = appendParamsToURL('', obj) + queryString.replace('?', '&');
      window.history.pushState({}, '', urlWithParams);

      const searchURL = appendParamsToURL(url, obj) + queryString.replace('?', '&');
      setSearchParams(searchURL);
      getSortedItems(searchURL, dispatch);
    } else if (urlParams.has('order')) {
      const temp = [...urlParams.entries()];
      const temp2 = [['sort_by', attributeName], ['order', orderList]];

      temp.map((value) => {
        temp2.map((value2) => {
          if (value[0] === value2[0]) {
            urlParams.set(value[0], value2[1]);
          }
        });
      });

      window.history.pushState({}, '', `?${urlParams.toString()}`);
      setSearchParams(`${url}?${urlParams.toString()}`);
      getSortedItems(`${url}?${urlParams.toString()}`, dispatch);
    } else {
      window.history.pushState({}, '', appendParamsToURL('', obj));
      const searchURL = appendParamsToURL(url, obj);
      setSearchParams(searchURL);
      getSortedItems(searchURL, dispatch);
    }
  };
  const handlerErrors = (e) => {
    const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;
    const status = e?.status || e?.response?.status;
    if (status === 403) {
      if (changeAppRedirectTo) {
        navigate(changeAppRedirectTo, { replace: true,  
          state: {
            from: location.pathname,
          }
         });
        return;
      }
    }
    if (e.button) {
      setButtonError(e.button);
    }
    setErrors(messages);
    if (!e.button) {
      setTimeout(() => {
        setErrors({});
      }, 5000);
    }
  };

  const handlerCreate = (item) => {
    console.log(configFile);
    setErrors({});
    const url = composeURL(session, configFile.sessionParams, configFile.createURL, id);
    return createItem(
      url,
      item,
      dispatch,
    ).then(() => {
      if (configFile.revalidate)
         revalidate();
      
      if (values.currentPage > 0) {
        // console.log(values);
        getItems(values.firstPageUrl, dispatch);
        navigate(getURLParams(values.firstPageUrl),{
           state: {
            from: location.pathname,
          }
        });
      }
      onCreate(item);
      return item
    }, (e) => {

      handlerErrors(e);
      return {}
    });
  };

  const handlerClickRow = (newitemsSelected) => {
    setitemsSelected(newitemsSelected);
    onChange(newitemsSelected);
  };

  const getData = () => {
    if (configFile.length == 0 || checkObjectAttributes(session, configFile.sessionParams)) {
      let url = composeURL(session, configFile.sessionParams, configFile.getURL, id);
      url += location.search;
      getItems(url, dispatch)
    }
  };

  const delayedQuery = useCallback(_.debounce((dataSet) => {
    const url = (dataSet.newValue == "status") ? composeURL(session, configFile.sessionParams, configFile.updateURL, dataSet.dataSetIndex) : composeURL(session, configFile.sessionParams, configFile.updateURL, id);
    updateItems(url, dataSet, dispatch, configFile.updateValuesAfterUpdate)
      .then(() => {

      }, (e) => {
        handlerErrors(e);
      });
  }, 300), [session, configFile, id]);

  const handlerUpdateRow = (dataRow) => {
    const url = composeURL(session, configFile.sessionParams, configFile.updateRowURL, dataRow.id);
    updateRowItems(url, dataRow, dispatch)
      .then(() => {
        // console.log("1");
      }, (e) => {
        handlerErrors(e);
      });

  }
  const handlerUpdate = (dataSet) => {
    setUpdateValues(dataSet);
    if (configFile.autoUpdate === true) {
      delayedQuery(dataSet);
    } else {
      tableEdited(dispatch);
    }
    onChange(dataSet);
  };

  const handlerUpdateOrderItems = (dataSet) => {
    setUpdateValues(dataSet);
    if (configFile.autoUpdate === true) {
      const url = composeURL(session, configFile.sessionParams, configFile.updateURL, id);
      updateItems(url, dataSet, dispatch)
        .then(() => {
          getData();
        }, (e) => {
          handlerErrors(e);
        });
    } else {
      tableEdited(dispatch);
    }
    onChange(dataSet);
  };

  const handlerSaveButton = () => {
    setErrors({});
    const url = composeURL(session, configFile.sessionParams, configFile.updateURL, id);

    updateItems(url, updatedValues, dispatch)
      .then(() => {
        onSave();
        tableEdited(dispatch, false);
        swal({
          title: 'Good job!',
          text: 'The table was updated!',
          icon: 'success',
        });
      }, (e) => {
        handlerErrors(e);
      });
  };

  const handlerRemoveItem = (item) => {
    let hasUsersOrganization = !!item?.has_users;
    let hasBillingOrganization = !!item?.has_billing_months || !!item?.has_billing_transaction;
    let hasBillingAgreement = !!item?.has_billing_transaction_agreement;
    let hasConfig = !!item?.hasConfig;
    let buttons = ["Cancel", "OK"];
    let removeTitle = configFile.removeTitle ? configFile.removeTitle : 'Are you sure?';
    let removeText = configFile.removeText ? configFile.removeText : 'You are removing a item.';
    if (configFile.removeNameField) {
      let name = item[configFile.removeNameField];
      removeText = removeText.replace('##' + configFile.removeNameField + '##', '"' + name + '"');
      removeTitle = removeTitle.replace('##' + configFile.removeNameField + '##', name);
    }
    if (configFile.buttonOkText) {
      buttons[1] = configFile.buttonOkText;
    }
    if (hasUsersOrganization || hasBillingOrganization || hasBillingAgreement || hasConfig) {
      let messages = [];
      if (hasUsersOrganization) {
        messages.push('This organization has users assigned and cannot be deleted.');
      }
      if (hasBillingOrganization) {
        messages.push('This organization has billing records and cannot be deleted.');
      }
      if (hasBillingAgreement) {
        messages.push('This agreement has billing records and cannot be deleted.');
      }
      if(hasConfig){
        messages.push('The language cannot be deleted because it is used by a configuration');
      }
      swal({
        title: 'Action blocked',
        text: messages.join('\n'),
        icon: 'warning',
        button: {
          text: buttons[1],
          className: "bg-warning"
        }
      });
      return;
    }
    swal({
      title: removeTitle,
      text: removeText,
      icon: 'warning',
      buttons: buttons,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = composeURL(session, configFile.sessionParams, configFile.removeURL, id);

        function buildDynamicMessage(obj, prefix = '') {
          let message = '';

          if (Array.isArray(obj)) {
            obj.forEach(item => {
              message += buildDynamicMessage(item, prefix);
            });
          } else if (typeof obj === 'object' && obj !== null) {

            if (obj.items && Array.isArray(obj.items)) {
              message += `${prefix}- ${capitalize(obj.description)}:\n`;
              obj.items.forEach(i => {
                message += `\u00A0\u00A0\u00A0\u00A0• Name: ${i.name}, Id: ${i.id}\n`;
              });
            } else if (obj.value !== undefined) {
              message += `${prefix}- ${capitalize(obj.description)}: ${obj.value}\n`;
            } else {
              for (const key in obj) {
                const value = obj[key];
                message += buildDynamicMessage({ [key]: value }, prefix);
              }
            }

          } else {
            message += `${prefix}- ${obj}\n`;
          }

          return message;
        }

        function capitalize(str) {
          if (!str) return '';
          return str.charAt(0).toUpperCase() + str.slice(1);
        }

        if (configFile.removeReconfirmMessage) {
          if (configFile.removeReconfirmURL) {
            httpGet(configFile.removeReconfirmURL + "/" + item.id).then((res) => {
              if (res.length > 0) {
                let list = buildDynamicMessage(res);
                swal({
                  title: 'Are you really sure?',
                  text: configFile.removeReconfirmMessage + '\n' + list,
                  icon: 'warning',
                  buttons: true,
                  dangerMode: true,
                }).then((willReDelete) => {
                  if (willReDelete == true) {
                    removeItem(url, item, dispatch).then((result) => {
                      if (configFile.revalidate) {
                        revalidate();
                      }
                      getData();
                      //removing items if it was selected
                      const newItemsSelected = itemsSelected.filter((itemSelected) => {
                        return itemSelected.id != item.id;
                      })
                      setitemsSelected(newItemsSelected);

                      onDelete(result);
                    }, (e) => {
                      handlerErrors(e);
                    });
                  }
                });
              } else {
                removeItem(url, item, dispatch).then((result) => {
                  getData();

                  //removing items if it was selected
                  const newItemsSelected = itemsSelected.filter((itemSelected) => {
                    return itemSelected.id != item.id;
                  })
                  setitemsSelected(newItemsSelected);

                  onDelete(result);
                }, (e) => {
                  handlerErrors(e);
                });
              }
              // window.location.reload();

            }).catch(e => {
              const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;
              setErrors(messages);
            });
          }

        } else {
          removeItem(url, item, dispatch).then((result) => {
            getData();

            //removing items if it was selected
            const newItemsSelected = itemsSelected.filter((itemSelected) => {
              return itemSelected.id != item.id;
            })
            setitemsSelected(newItemsSelected);

            onDelete(result);
          }, (e) => {
            handlerErrors(e);
          });
        }
      }
    });
  };

  const handlerOnChangeItemPosition = (item) => {
    const url = composeURL(session, configFile.sessionParams, configFile.removeURL, item.id);
    updateItem(url, { ...item, toOrder: true }, dispatch).then(() => {
      getData();
    }, (e) => {
      handlerErrors(e);
    });
  };

  const onBroadCastingNavigationReceived = (e) => {
    let stateObj = JSON.parse(serializedState);
    let navURL = configFile.getURL;
    if (configFile.idAttribute)
      navURL = composeURL(null, null, configFile.getURL, id);
    let pageUserNav = [];
    let dataObj = JSON.parse(e.data);
    dataObj.forEach((item) => {
      if (item.page == process.env.REACT_APP_API_ENDPOINT + navURL) {
        if (item.email == stateObj.sessionEmail) {
          item.me = true;
        } else {
          item.me = false;
        }
        pageUserNav.push(item);
      }
    })
    setUserNavigation(pageUserNav);
  }
  const onBroncastingReceived = (e, currentPage) => {
    if (currentPage === 1) {
      updateLocalItem(e[configFile.websocketItem], dispatch);
    }
  };

  const handlerExportButton = () => {
    const url = composeURL(session, configFile.sessionParams, configFile.exportAction, id);
    httpGetFile(url, configFile.exportName);
  };

  const handlerUploadSync = () => {
    if (configFile.importMonitoringChanel) {
      setWebsocketLogOpen(true);
    } else {
      window.location.reload();
    }
  };

  const handlerCloseWebsocket = () => {
    setWebsocketLogOpen(false);
    window.location.reload();
  };
  const importPopup = () => {
    setShowImportPopup(true);
  }
  const closeImportPopup = () => {
    setShowImportPopup(false);
  }
  const handlerBulkAction = (action, itemsSelected, type) => {
    var promise = new Promise((resolve, reject) => {
      if (action == "bulkImport" || action == "bulkEdit") {
        //never passes here
      } else {
        swal({
          title: 'Are you sure?',
          text: 'You are about to ' + action + ' over ' + itemsSelected.length + ' items.',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then((ok) => {
          if (ok) {
            if (action == "bulkExport") {
              setExports(["Preparing the file to be exported..."]);
              setButtonExport(null);
              const idsToSend = itemsSelected.map((itemToSend) => {
                return itemToSend.id;
              });
              const url = composeURL(session, configFile.sessionParams, configFile.getURL);
              setitemsSelected([]);

              bulk(url, { action: action, ids: idsToSend, type: type }, dispatch).then((urlExport) => {
                let b = { id: "button-bulkExported", title: "Export", actionUrl: urlExport, actionParams: idsToSend };
                setButtonExport(b);
                setExports(["here is the file exported"]);
                resolve(true);
              }, (e) => {
                handlerErrors(e);

              });

            }
            else {
              setLoadingSpinner(true);
              const idsToSend = itemsSelected.map((itemToSend) => {
                return itemToSend.id;
              });
              const url = composeURL(session, configFile.sessionParams, configFile.getURL);
              setitemsSelected([]);
              bulk(url, { action: action, ids: idsToSend }, dispatch).then(() => {
                getItems(`${values.path}?page=${values.currentPage}`, dispatch);
                setLoadingSpinner(false);
              }, (e) => {
                handlerErrors(e);
                setLoadingSpinner(false);

              });
              resolve(true);
            }
          } else {
            reject("error");
          }
        });
      }
    });
    return promise;
  }
  const handlerBulkDelete = (itemsToRemove) => {
    // swal({
    //   title: 'Are you sure?',
    //   text: 'You are removing '+itemsToRemove.length+' items.',
    //   icon: 'warning',
    //   buttons: true,
    //   dangerMode: true,
    // }).then((willDelete) => {
    //   if (willDelete) {
    //     const idsToRemove = itemsToRemove.map((itemToRemove) => {
    //       return itemToRemove.id;
    //     });
    //     const url = composeURL(session, configFile.sessionParams, configFile.getURL);
    //     setitemsSelected([]);
    //     bulk(url,{deletes: idsToRemove}, dispatch).then(() => {
    //       getItems(`${values.path}?page=${values.currentPage}`, dispatch);
    //     }, (e) => {
    //       handlerErrors(e);

    //     });
    //   }
    // });
  };
  const runList = () => {
    setitemsSelected([]);
    getData();
    return function cleanup() {
      resetList(dispatch);
    };
  }
  const sessionDependencies = configFile.sessionParams.map((param) => session[param]);
  const sessionDependenciesKey = JSON.stringify(sessionDependencies);
  useEffect(() => {
    if (withSessionVariables) {
      if (withSessionVariables.includes("appId") && withSessionVariables.includes("areaId")) {
        if ((session.areaId != undefined && session.appId != undefined) ||
          !withSessionVariables) {
          runList();
        }
      } else if (withSessionVariables.includes("appId") && !withSessionVariables.includes("areaId")) {
        if (session.appId != undefined) {
          runList();
        }
      }
    } else {
      runList();
    }
  }, [configFile, session.mainHubId, sessionDependenciesKey, navigate]);

  useEffect(() => {
    if (selValue && selValue.allCategories) {
      console.log("TBD to display all categories element");
    }
    if (selValue && selValue.tableValue && selValue.tableValue.id) {
      // console.log("111",selValue.tableValue);
      setitemsSelected([selValue.tableValue]);
    } else if (selValue && selValue.tableValue && selValue.tableValue.ids) {
      if (selValue.tableValue.ids[0] != "all") {
        setitemsSelected(selValue.tableValue.ids);
      }
    } else {
      if (selValue && selValue.tableValue)
        setitemsSelected(selValue.tableValue);
    }
  }, [selValue]);
  useEffect(() => {
    if(setIsSpaceSelectDisabled )
    setIsSpaceSelectDisabled(configFile.disableArea ?? false);
  }, [setIsSpaceSelectDisabled, configFile, location]);
  const handleActionUrl = (actionUrl, actionParams) => {
    setErrors([]);
    httpPost(actionUrl, {}).then((res) => {
      window.location.reload();
    }).catch(e => {
      const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;
      setErrors(messages);
    });

  }

  const handleExportClose = () => {
    setExports([]);
    setButtonExport(null);
  }
  const handleExport = (actionUrl, params) => {
    // console.log("action",actionUrl);
    // console.log("params",params);
    const link = document.createElement('a');
    link.href = actionUrl;
    const filenameWithExtension = actionUrl.split('/').pop();

    link.download = 'my_file.rar';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setExports([]);

  }

  return (
    <div>
      {configFile.websocketNavigation
        && (
          <Broadcast
            eventChanel={configFile.websocketNavigation}
            sessionParams={[]}
            onEventReceived={(e) => { onBroadCastingNavigationReceived(e); }}
          />
        )}
      {configFile.websocketEventChanel && values.data !== undefined
        && (
          <Broadcast
            eventChanel={configFile.websocketEventChanel}
            sessionParams={configFile.sessionWebsocketParams}
            onEventReceived={(e) => { onBroncastingReceived(e, values.currentPage); }}
          />
        )}
      {configFile.noArea && (configFile.noTitle === undefined || configFile.noTitle === false)
        && (
          <SimplePageTitle myEmail={JSON.parse(serializedState).sessionEmail} userNavigation={(userNavigation.length > 0 ? userNavigation : values.usersNavigation)}>{configFile.title}</SimplePageTitle>
        )}
      {(configFile.noArea === undefined || configFile.noArea === false) && (configFile.isMainHub === undefined || configFile.isMainHub === false)
        && (
          <PageTitle
            disableArea={configFile.disableArea == true ? true : false}
            disableConfig={configFile.disableArea == true ? true : false}
            myEmail={JSON.parse(serializedState).sessionEmail}
            userNavigation={(userNavigation.length > 0 ? userNavigation : values.usersNavigation)}
            operatingSystem={configFile.showOperatingSystem ? values.operatingSystem : ''}
            configs={configs || []}
            currentconfigId={currentconfigId}
            onChangeMainHubConfig={onChangeMainHubConfig}
            showMainHubConfigSelect={sportRoomId !== undefined}
            mainHubConfigRef={mainHubConfigRef}
          >
            {configFile.title}
          </PageTitle>
        )}
      {(configFile.noArea === undefined || configFile.noArea === false) && (configFile.isMainHub === true)
        && (
          <MainHubPageTitle configFile={configFile}>{configFile.title}</MainHubPageTitle>
        )}
      {Object.keys(errors).length > 0
        && (
          <Toaste type="error" mode="toast" data={errors} button={buttonError} onActionUrl={handleActionUrl} />
        )}
      {Object.keys(exports).length > 0
        && (
          <Toaste type="info" mode="toast" data={exports} button={buttonExport} onActionUrl={handleExport} onClose={handleExportClose} />
        )}

      {configFile.loadFromFile !== undefined
        && (
          <FormUploadSync
            endpoint={composeURL(session, configFile.sessionParams, configFile.loadFromFile, id)}
            helpText={configFile.loadFromFileHelp}
            fileExtensionType={configFile.fileExtensionType}
            onSuccess={handlerUploadSync}
          />
        )}
      {websocketLogOpen
        && (
          <WebsocketLog
            withModal
            title={configFile.importMonitoringTitle}
            eventChanel={configFile.importMonitoringChanel}
            sessionParams={configFile.importMonitoringSessionParams}
            handlerClose={() => handlerCloseWebsocket()}
          />
        )}
      {configFile.exportAction
        && (
          <div className="form-group row">
            <Label helpText={configFile.exportHelp}>{configFile.exportHelp}</Label>
            <div className="col-sm-8">
              <Button theme={ButtonTheme.INFO} onClick={handlerExportButton}>Download file</Button>
            </div>
          </div>
        )}
      {values.data !== undefined
        && (
          <TableSection
            configFile={configFile.tableConfig}
            urlParams={configFile}
            valuesPaginated={values}
            id={id}
            session={session}
            onChangePage={handlerChangePage}
            onSearch={handleFilter}
            onClickCreate={handlerCreate}
            onChangeItem={handlerUpdate}
            onChangeRow={handlerUpdateRow}
            onClickRemoveItem={handlerRemoveItem}
            onChangeItemPosition={handlerOnChangeItemPosition}
            onClickBulkDelete={handlerBulkDelete}
            onBulkAction={handlerBulkAction}
            onOrderItems={(dataValues, isDrag) => {
              if (isDrag) {
                handlerUpdate(dataValues);
              } else {
                handlerUpdateOrderItems(dataValues);
              }
            }}
            onSort={handlerSort}
            onClickRow={handlerClickRow}
            initDataSelected={configFile?.tableConfig?.isMultiSelectable === true || selValue != null ? itemsSelected : []}
          />
        )}
      <PreventTransitions />
      {itemChanged === true && (configFile.autoUpdate == undefined || configFile.autoUpdate == false)
        && (
          <div class="footer-section">
            <FooterButton onClick={handlerSaveButton}>Save</FooterButton>
          </div>
        )}
      {showImportPopup &&
        <div>popup to be shown
          <button label="close" title="close" onClick={closeImportPopup}>Close popup</button>
        </div>
      }
      {loadingSpinner &&
        <LoadingSpinnerPage />
      }
    </div>
  );
};

ListTableTemplate.propTypes = {
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({
    noArea: PropTypes.bool,
    title: PropTypes.string,
    getURL: PropTypes.string,
    createURL: PropTypes.string,
    updateURL: PropTypes.string,
    removeURL: PropTypes.string,
    idAttribute: PropTypes.string,
    websocketEventChanel: PropTypes.string,
    sessionParams: PropTypes.arrayOf(PropTypes.string),
    sessionWebsocketParams: PropTypes.arrayOf(PropTypes.string),
    loadFromFile: PropTypes.string,
    loadFromFileHelp: PropTypes.string,
    exportAction: PropTypes.string,
    exportHelp: PropTypes.string,
    exportName: PropTypes.string,
    websocketItem: PropTypes.string,
    updateValuesAfterUpdate: PropTypes.arrayOf(PropTypes.string),
    autoUpdate: PropTypes.bool,
    importMonitoringChanel: PropTypes.string,
    importMonitoringTitle: PropTypes.string,
    importMonitoringSessionParams: PropTypes.arrayOf(PropTypes.string),
    tableConfig: PropTypes.shape({
      fields: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }).isRequired,
  onCreate: PropTypes.func,
  onChange: PropTypes.func,
  onChangeRow: PropTypes.func,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
};

ListTableTemplate.defaultProps = {
  onCreate: () => { },
  onSave: () => { },
  onDelete: () => { },
  onChange: () => { },
  onChangeRow: () => { }
};

export default ListTableTemplate;
